export const AGENT_ID_FIELD = "agent_id";
export const AGENT_FLEET_ID_FIELD = "agent_fleet_id";
export const AGENT_SOURCE_ID_FIELD = "agent_source_id";
export const AGENT_RECEIVER_TYPE_FIELD = "agent_receiver_type";
export const COLLECTOR_LOG_RECEIVER_TYPE = "collector_log";
export const COLLECTOR_SYSTEM_LOGS_STREAM_ID = "000000000000000000000005";
